import React from 'react';
import BottomSheet from '../../../../Components/Ui/BottomSheet';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../../Components/MUIs';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

export default function RejectCheckBottomSheet() {
  const dispatch = useDispatch();
  const { baseInfo } = useSelector((state) => state.permit);

  return (
    <BottomSheet isHeaderChildren={true} headerText={'반려 내용'}>
      <Box sx={{ px: 1, mb: 2, py: 1, backgroundColor: '#FAFAFA' }}>
        <Typography
          style={{
            color: '#3A3A3A',
            fontSize: '18px',
          }}
        >
          {baseInfo.returnReason}
        </Typography>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Button
          name="확인"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={() => {
            dispatch(BottomSheetActions.CloseBottomSheet());
          }}
        />
      </Box>
    </BottomSheet>
  );
}
